module.exports = __webpack_public_path__ + "img/white-dot.8c69c46.png";